import React from 'react';
import BlogDetails from '../../components/blog/BlogDetails';
import PageMeta from '../../components/common/PageMeta';
import PageHeader from '../../components/common/PageHeader';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';

const Blog1 = () => {
  return (
    <Layout>
      <PageMeta title="VERA: Tutorial on Participating in the Testing of the Virtual Experience Research Accelerator" />
      <Navbar navDark />
      <PageHeader title="VERA: Tutorial on Participating in the Testing of the Virtual Experience Research Accelerato" />
      <BlogDetails />
      {/* <NewsLetter />
      <LatestBlog />
      <CtaTwo />
      <FooterOne footerLight /> */}
    </Layout>
  );
};

export default Blog1;
